import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import NotesForm from './NotesForm';

const styles = () => ({
  root: {
    width: 472,
    textAlign: 'left',
  },
  footer: {
    padding: '0 16px',
  },
});

const NotesTooltipContent = ({
  classes,
  onSubmitSuccess,
  onSubmitButtonBlur,
  rootRef,
  createInputRef,
  ...otherProps
}) => (
  <div
    ref={rootRef}
    className={classes.root}
  >
    <div className={classes.footer}>
      <NotesForm
        {...{ 'User Record Number': otherProps['User Record Number'] }}
        {...{ 'Author ID': otherProps['Author ID'] }}
        variant="patient"
        form={`${otherProps['User Record Number']}-patient-note-create`}
        destroyOnUnmount={false}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitButtonBlur={onSubmitButtonBlur}
        onSubmitButtonClick={onSubmitSuccess}
        inputRef={createInputRef}
      />
    </div>
  </div>
);

NotesTooltipContent.propTypes = {
  'User Record Number': PropTypes.number.isRequired,
  'Author ID': PropTypes.number.isRequired,
  onSubmitSuccess: PropTypes.func,
  onSubmitButtonBlur: PropTypes.func,
  rootRef: PropTypes.func,
  createInputRef: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
};

NotesTooltipContent.defaultProps = {
  onSubmitSuccess: () => {},
  onSubmitButtonBlur: () => {},
  rootRef: () => {},
  createInputRef: () => {},
};

export default withStyles(styles)(NotesTooltipContent);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Notes/NotesTooltipContent.js